import type { ReactNode } from 'react';
import { BlockStack, Box } from '@pv-frontend/ui-components-web';

/**
 * Full-viewport centered column for the login / loading / denied states. The
 * one inline flex wrapper does the vertical centering RN gets for free (every
 * RN View is a flex column) — the design-system primitives cover the rest.
 */
export function Centered({ children }: { children: ReactNode }) {
    return (
        <Box background="bg" width="100%" height="100%" minHeight={480} padding="600">
            <div style={{ display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <BlockStack align="center" inlineAlign="center" gap="400">
                    {children}
                </BlockStack>
            </div>
        </Box>
    );
}
